import { API_ROOT } from '../../config/config'
import { doPost } from './utils'

export const getGetOtp = (request) => {
  const url = `${API_ROOT}/identity/logon/generate-otp`
  return doPost(url, request)
}

export const getLoginOtp = (request) => {
  const url = `${API_ROOT}/identity/logon/validate-otp`
  return doPost(url, request)
}
